import { Component, input, output } from '@angular/core';
import { View } from '../shared/classes/view.enum';
import { Supplier } from '../shared/classes/supplier';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
/**
 * The header bar containing the Siemens Healthineers logo and the user's
 * company name. Clicking the logo change the form to the home page.
 */
export class HeaderComponent {
    public readonly supplier = input.required<Supplier>();
    public readonly viewChange = output<View>();

    /**
     * Changes which component is displayed in the "form" section of the page.
     * Called when Siemens Healthineers logo is clicked.
     */
    switchToHomeView(): void {
        this.viewChange.emit(View.HOME);
    }
}
